function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { searchableComponent } from '../../utils';
import accordion from './accordion';
import avatar from './avatar';
import backdrop from './backdrop';
import button from './button';
import checkbox from './checkbox';
import dropdown from './dropdown';
import icons from './icons';
import inlineLink from './inlineLink';
import input from './input';
import modal from './modal';
import progressIndicator from './progressIndicator';
import quote from './quote';
import radio from './radio';
import statusLabel from './statusLabel';
import switch_t from './switch_t';
import tag from './tag';
import textarea from './textarea';
import toast from './toast';
import tooltip from './tooltip';
import typography from './typography';
var tokens = {
  "fontSizes": {
    "xs": "12px",
    "sm": "14px",
    "md": "16px",
    "lg": "18px",
    "xl": "20px",
    "2xl": "22px",
    "3xl": "24px",
    "4xl": "28px",
    "5xl": "32px",
    "6xl": "40px",
    "7xl": "48px",
    "8xl": "56px",
    "9xl": "64px",
    "10xl": "72px"
  },
  "fontFamily": {
    "base": "Helvetica Now Display"
  },
  "fontWeight": {
    "xs": 300,
    "sm": 400,
    "md": 500,
    "lg": 700
  },
  "letterSpacing": {
    "xs": "0.3",
    "sm": "0.5",
    "md": "1.5"
  },
  "lineHeight": {
    "xs": "16px",
    "sm": "20px",
    "md": "24px",
    "lg": "26px",
    "xl": "28px",
    "2xl": "32px",
    "3xl": "36px",
    "4xl": "40px",
    "5xl": "52px",
    "6xl": "64px",
    "7xl": "72px",
    "8xl": "96px"
  },
  "colors": {
    "error": {
      "60": "#de1212"
    },
    "neutral": {
      "0": "#ffffff",
      "10": "#edf0ef",
      "15": "#dbe1dd",
      "20": "#c7cec9",
      "40": "#a5aea7",
      "60": "#6f7974",
      "80": "#596b64",
      "90": "#1f2d27",
      "100": "#000000",
      "transparent": "#1f2d27"
    },
    "primary": {
      "40": "#49e295",
      "60": "#11bb77",
      "80": "#23a969",
      "90": "#0f7c50"
    },
    "secondary": {
      "20": "#97daff",
      "40": "#1b75dd",
      "60": "#2159a2"
    },
    "warning": {
      "60": "#b46100"
    },
    "informational": {
      "60": "#3d9c96"
    }
  },
  "spacingX": {
    "xs": "2px",
    "sm": "4px",
    "md": "8px",
    "lg": "10px",
    "xl": "12px",
    "2xl": "14px",
    "3xl": "16px",
    "4xl": "18px",
    "5xl": "20px",
    "6xl": "24px",
    "7xl": "28px",
    "8xl": "32px",
    "9xl": "36px",
    "10xl": "40px",
    "11xl": "44px",
    "12xl": "48px",
    "13xl": "52px",
    "14xl": "56px",
    "15xl": "60px",
    "16xl": "64px",
    "17xl": "68px",
    "18xl": "72px",
    "19xl": "76px",
    "20xl": "80px",
    "21xl": "96px",
    "22xl": "128px",
    "23xl": "160px"
  },
  "spacingY": {
    "xs": "2px",
    "sm": "4px",
    "md": "8px",
    "lg": "10px",
    "xl": "12px",
    "2xl": "14px",
    "3xl": "16px",
    "4xl": "18px",
    "5xl": "20px",
    "6xl": "24px",
    "7xl": "28px",
    "8xl": "32px",
    "9xl": "36px",
    "10xl": "40px",
    "11xl": "44px",
    "12xl": "48px",
    "13xl": "52px",
    "14xl": "56px",
    "15xl": "60px",
    "16xl": "64px",
    "17xl": "68px",
    "18xl": "72px",
    "19xl": "76px",
    "20xl": "80px",
    "21xl": "96px",
    "22xl": "128px",
    "23xl": "160px"
  },
  "spacingBottom": {
    "xs": "2px",
    "sm": "4px",
    "md": "8px",
    "lg": "10px",
    "xl": "12px",
    "2xl": "14px",
    "3xl": "16px",
    "4xl": "18px",
    "5xl": "20px",
    "6xl": "24px",
    "7xl": "28px",
    "8xl": "32px",
    "9xl": "36px",
    "10xl": "40px",
    "11xl": "44px",
    "12xl": "48px",
    "13xl": "52px",
    "14xl": "56px",
    "15xl": "60px",
    "16xl": "64px",
    "17xl": "68px",
    "18xl": "72px",
    "19xl": "76px",
    "20xl": "80px",
    "21xl": "96px",
    "22xl": "128px",
    "23xl": "160px"
  },
  "spacingRight": {
    "xs": "2px",
    "sm": "4px",
    "md": "8px",
    "lg": "10px",
    "xl": "12px",
    "2xl": "14px",
    "3xl": "16px",
    "4xl": "18px",
    "5xl": "20px",
    "6xl": "24px",
    "7xl": "28px",
    "8xl": "32px",
    "9xl": "36px",
    "10xl": "40px",
    "11xl": "44px",
    "12xl": "48px",
    "13xl": "52px",
    "14xl": "56px",
    "15xl": "60px",
    "16xl": "64px",
    "17xl": "68px",
    "18xl": "72px",
    "19xl": "76px",
    "20xl": "80px",
    "21xl": "96px",
    "22xl": "128px",
    "23xl": "160px"
  },
  "spacingTop": {
    "xs": "2px",
    "sm": "4px",
    "md": "8px",
    "lg": "10px",
    "xl": "12px",
    "2xl": "14px",
    "3xl": "16px",
    "4xl": "18px",
    "5xl": "20px",
    "6xl": "24px",
    "7xl": "28px",
    "8xl": "32px",
    "9xl": "36px",
    "10xl": "40px",
    "11xl": "44px",
    "12xl": "48px",
    "13xl": "52px",
    "14xl": "56px",
    "15xl": "60px",
    "16xl": "64px",
    "17xl": "68px",
    "18xl": "72px",
    "19xl": "76px",
    "20xl": "80px",
    "21xl": "96px",
    "22xl": "128px",
    "23xl": "160px"
  },
  "spacingLeft": {
    "xs": "2px",
    "sm": "4px",
    "md": "8px",
    "lg": "10px",
    "xl": "12px",
    "2xl": "14px",
    "3xl": "16px",
    "4xl": "18px",
    "5xl": "20px",
    "6xl": "24px",
    "7xl": "28px",
    "8xl": "32px",
    "9xl": "36px",
    "10xl": "40px",
    "11xl": "44px",
    "12xl": "48px",
    "13xl": "52px",
    "14xl": "56px",
    "15xl": "60px",
    "16xl": "64px",
    "17xl": "68px",
    "18xl": "72px",
    "19xl": "76px",
    "20xl": "80px",
    "21xl": "96px",
    "22xl": "128px",
    "23xl": "160px"
  },
  "radius": {
    "xs": "2px 2px 2px 2px",
    "sm": "4px 4px 4px 4px",
    "md": "6px 6px 6px 6px",
    "lg": "8px 8px 8px 8px",
    "xl": "10px 10px 10px 10px",
    "2xl": "12px 12px 12px 12px",
    "3xl": "14px 14px 14px 14px",
    "4xl": "16px 16px 16px 16px",
    "5xl": "18px 18px 18px 18px",
    "6xl": "20px 20px 20px 20px",
    "7xl": "22px 22px 22px 22px",
    "8xl": "24px 24px 24px 24px",
    "pill": "500px 500px 500px 500px",
    "round": "5000px 5000px 5000px 5000px"
  },
  "motion": {
    "xs": "0.2s",
    "sm": "0.4s",
    "md": "0.6s",
    "lg": "0.8s",
    "xl": "1.0s"
  },
  "opacity": {
    "xs": "0.050",
    "sm": "0.100",
    "md": "0.250",
    "lg": "0.500",
    "xl": "0.750",
    "2xl": "0.900",
    "3xl": "0.950"
  },
  "stroke": {
    "xs": "1px",
    "sm": "2px",
    "md": "4px",
    "lg": "8px"
  },
  "shadow": {
    "xs": "0px 2px 5px rgba(199, 206, 201, 0.16), 0px 0px 1px rgba(165, 174, 167, 0.90)",
    "sm": "0px 12px 12px rgba(0, 0, 0, 0.08), 0px 0px 8px rgba(0, 0, 0, 0.08)",
    "md": "0px 16px 12px -8px rgba(0, 0, 0, 0.16), 0px 16px 8px -12px rgba(0, 0, 0, 0.12)",
    "lg": "0px 28px 64px rgba(20, 20, 20, 0.16)"
  },
  "breakpoints": {
    "xs": "320",
    "sm": "360",
    "md": "375",
    "lg": "400",
    "xl": "480",
    "2xl": "600",
    "3xl": "768",
    "4xl": "880",
    "5xl": "1024",
    "6xl": "1280",
    "7xl": "1366",
    "8xl": "1440",
    "9xl": "1920"
  },
  "elevation": {
    "xs": "2",
    "sm": "8",
    "md": "24"
  },
  "shadowOpacity": {
    "xs": "0.8",
    "sm": "0.16"
  },
  "shadowRadius": {
    "xs": "5",
    "sm": "12",
    "md": "20",
    "lg": "64"
  },
  "shadowOffsetHeight": {
    "xs": "2",
    "sm": "8",
    "md": "16",
    "lg": "28"
  },
  "shadowOffsetWidth": {
    "xs": "0"
  }
};
var breakpoints = Object.values(tokens.breakpoints).map(value => "".concat(value, "px"));
Object.keys(tokens.breakpoints).forEach(media => {
  breakpoints[media] = "".concat(tokens.breakpoints[media], "px");
});

var standardTheme = _objectSpread(_objectSpread({}, tokens), {}, {
  breakpoints,
  accordion: searchableComponent(accordion.bind(null, tokens)),
  avatar: searchableComponent(avatar.bind(null, tokens)),
  backdrop: searchableComponent(backdrop.bind(null, tokens)),
  button: searchableComponent(button.bind(null, tokens)),
  checkbox: searchableComponent(checkbox.bind(null, tokens)),
  dropdown: searchableComponent(dropdown.bind(null, tokens)),
  icons: searchableComponent(icons.bind(null, tokens)),
  inlineLink: searchableComponent(inlineLink.bind(null, tokens)),
  input: searchableComponent(input.bind(null, tokens)),
  modal: searchableComponent(modal.bind(null, tokens)),
  progressIndicator: searchableComponent(progressIndicator.bind(null, tokens)),
  quote: searchableComponent(quote.bind(null, tokens)),
  radio: searchableComponent(radio.bind(null, tokens)),
  statusLabel: searchableComponent(statusLabel.bind(null, tokens)),
  switch_t: searchableComponent(switch_t.bind(null, tokens)),
  tag: searchableComponent(tag.bind(null, tokens)),
  textarea: searchableComponent(textarea.bind(null, tokens)),
  toast: searchableComponent(toast.bind(null, tokens)),
  tooltip: searchableComponent(tooltip.bind(null, tokens)),
  typography: searchableComponent(typography.bind(null, tokens))
});

export default standardTheme;
//# sourceMappingURL=index.js.map